var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3078,
    cy: 17.3077,
    r: 14.4231,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.962 11.761C25.3257 12.0437 24.6409 12.2341 23.9227 12.32C24.6559 11.8804 25.219 11.1847 25.4837 10.3557C24.7984 10.763 24.0375 11.0578 23.2293 11.2176C22.5814 10.5276 21.6578 10.0961 20.6373 10.0961C18.6765 10.0961 17.0866 11.686 17.0866 13.6469C17.0866 13.9249 17.1183 14.196 17.1789 14.4562C14.2276 14.3085 11.6114 12.8946 9.85999 10.7463C9.55424 11.2707 9.37944 11.8804 9.37944 12.5312C9.37944 13.7628 10.0054 14.8497 10.959 15.4865C10.3763 15.4681 9.82941 15.3083 9.35002 15.0423V15.0868C9.35002 16.8076 10.5747 18.2423 12.1981 18.5694C11.9004 18.6502 11.5866 18.694 11.263 18.694C11.0339 18.694 10.8113 18.6715 10.5944 18.63C11.0461 20.0405 12.3579 21.0673 13.9114 21.0962C12.6965 22.048 11.1655 22.6163 9.50174 22.6163C9.21445 22.6163 8.93178 22.5995 8.6543 22.5661C10.2257 23.5733 12.092 24.1617 14.0972 24.1617C20.6281 24.1617 24.1996 18.7511 24.1996 14.0593C24.1996 13.9053 24.1967 13.7519 24.1892 13.6001C24.8838 13.0982 25.4861 12.4729 25.962 11.761Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRound);
export default __webpack_public_path__ + "static/media/twitterRound.8e786012ad4088da8a8edfd6e47d3348.svg";
export { ForwardRef as ReactComponent };